import { FC } from 'react'
import { Container, SpaceBetween } from '@cloudscape-design/components'

import GenericTagsNew from '../../../ControlledFormInputs/GenericTagsNewGCP'

const Tags: FC = () => {
	return (
		<SpaceBetween direction="vertical" size="l">
			<Container>
				<GenericTagsNew />
			</Container>
		</SpaceBetween>
	)
}

export default Tags
